var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFFDFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4301 17.5C10.0759 17.5 9.72156 17.3641 9.44467 17.0909C8.87233 16.525 8.84951 15.5837 9.3935 14.9884L12.5933 11.4896L9.39676 8.01503C8.85076 7.42181 8.87082 6.48048 9.44166 5.91256C10.0127 5.34463 10.9179 5.36576 11.4639 5.95923L15.6034 10.458C16.1311 11.0317 16.1321 11.9352 15.6067 12.5107L11.4674 17.0377C11.1858 17.3446 10.8088 17.5 10.4301 17.5Z",
    fill: "#436094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circle_arrow.c3f3269b9e32c0cefcf9d42ec476bf7e.svg";
export { ForwardRef as ReactComponent };